<template>
<div class="chapter">
<div class="inner_page">
<div class="SOM">
<h1 class="SOM_titre">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Foreword by Mark Batterson</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1">1 What Is Simple Prayer?</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2 Simple Prayer of the Heart</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 Simple Prayer of Faith</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 Simple Prayer of Forgiveness</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 Simple Prayer of Unity</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">6 Simple Prayer of Restoration</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">7 Simple Words to Pray</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">8 Simple Prayer of Finding Your Way</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Simple Prayer</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?8567c2f0